function Contact() {
	const subnavElementContactElement = document.querySelector('.about .subnav-about a[data-id="contact"]');

	function open() {
		BODY_ELEMENT.classList.add('body-about-contact');
		subnavElementContactElement.classList.add('active');
	}

	function close() {
		BODY_ELEMENT.classList.remove('body-about-contact');
		subnavElementContactElement.classList.remove('active');
	}

	this.open = open;
	this.close = close;
}

export default Contact;
